import React, {useState, useEffect} from "react"
import {useNavigate} from "react-router-dom"
import {useLanguage} from "../../context/LanguageContext"
import "./CategorySlider.css"
import {Config} from "../../Config/config"

export default function CategorySlider() {
  const {language} = useLanguage()
  const [categories, setCategories] = useState([])
  const navigate = useNavigate()

  const fetchCategories = (langCode) => {
    //    console.log("Fetching categories for language:", langCode)

    fetch(`${Config.ApiBaseUrl}/subcat/?category__firm=2&is_active=true`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${Config.Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        //       console.log("Fetched categories:", data)
        const filteredCategories = data
          .map((category) => {
            let langData = category.subcategorylang.find(
              (lang) => lang.language__code === langCode
            )

            if (!langData) {
              langData = category.subcategorylang.find(
                (lang) => lang.language__code === "TR"
              )
              console
                .log
                //      `No data for language ${langCode}, falling back to TR`
                ()
            }

            return langData
              ? {
                  id: category.id,
                  name: langData.name,
                  description: langData.description,
                  has_option: category.has_option,
                  image:
                    category.image ||
                    "https://via.placeholder.com/150x150.png?text=No+Image",
                  //  image:
                  //    "https://fastly.picsum.photos/id/637/1000/520.jpg?hmac=LXoaYXZySiVXGRM68kYcBYYWnIB4ubiSHqDx5FoTQ1I",
                }
              : null
          })
          .filter(Boolean)

        //    console.log("Filtered categories:", filteredCategories)
        setCategories(filteredCategories)
      })
    //  .catch((error) => console.error("Error fetching categories:", error))
  }

  useEffect(() => {
    if (language) {
      //     console.log("Language Changed to:", language)
      fetchCategories(language)
    }
  }, [language])

  const handleTabClick = (category) => {
    //  console.log("Tab clicked:", category)
    navigate("/show-all-menu", {
      state: {
        cardName: category.name,
        subCategoryId: category.id,
        hasOption: category.has_option,
      },
    })
  }

  return (
    <>
      <div className="horizontal-tabs">
        {categories.length === 0 ? (
          <div>Yükleniyor...</div>
        ) : (
          categories.map((category, index) => (
            <div
              key={index}
              className="tab-item"
              style={{
                backgroundImage: `url(${category.image})`,
              }}
              onClick={() => handleTabClick(category)}
            >
              <div className="tab-text">{category.name.toUpperCase()}</div>
            </div>
          ))
        )}
      </div>
    </>
  )
}
